import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/developmentData.json";

export default function Development() {
  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Разработка медицинских и организационных технологий
      </h1>

      <Accordion data={data} />
    </section>
  );
}
